import React from 'react';
import { ExternalLink } from 'lucide-react';

const UsefulLinks = () => {
  const links = [
    {
      category: "Offices de Tourisme",
      items: [
        { name: "Office de Tourisme Île de Ré", url: "https://www.iledere.com/", description: "Site officiel du tourisme" },
        { name: "Office de Tourisme Les Portes-en-Ré", url: "https://www.iledere.com/preparer/offices-de-tourisme/les-portes-en-re", description: "Infos locales et événements" },
        { name: "Office de Tourisme La Rochelle", url: "https://www.larochelle-tourisme.com/", description: "Destination La Rochelle" }
      ]
    },
    {
      category: "Activités & Loisirs",
      items: [
        { name: "Golf de Trousse-Chemise", url: "https://www.golf-iledere.com/", description: "Parcours 9 trous links" },
        { name: "Vélos Île de Ré", url: "https://www.iledere.com/bouger/a-velo", description: "Locations et pistes cyclables" },
        { name: "Marais Salants", url: "https://www.iledere.com/decouvrir/incontournables/marais-salants", description: "Visites et découverte du sel" }
      ]
    },
    {
      category: "Patrimoine & Culture",
      items: [
        { name: "Phare des Baleines", url: "https://www.lespharesilederé.fr/", description: "Monuments historiques" },
        { name: "Villages de l'Île", url: "https://www.iledere.com/decouvrir/villages", description: "10 villages authentiques" },
        { name: "Fortifications Vauban", url: "https://www.iledere.com/decouvrir/incontournables/fortifications-vauban", description: "Patrimoine UNESCO" }
      ]
    },
    {
      category: "Infos Pratiques",
      items: [
        { name: "Météo Île de Ré", url: "https://meteofrance.com/previsions-meteo-france/les-portes-en-re/17880", description: "Prévisions météo" },
        { name: "Horaires des Marées", url: "https://www.horaire-maree.fr/maree/France/Les+Portes-en-R%C3%A9/", description: "Pêche à pied" },
        { name: "Transports en commun", url: "https://www.rtcr.fr/", description: "Bus et navettes" }
      ]
    }
  ];

  return (
    <section className="bg-amber-50 py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Liens Utiles pour Votre Séjour</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {links.map((category, idx) => (
            <div key={idx} className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-lg font-semibold text-amber-700 mb-4 border-b border-amber-200 pb-2">
                {category.category}
              </h3>
              <ul className="space-y-3">
                {category.items.map((link, linkIdx) => (
                  <li key={linkIdx}>
                    <a 
                      href={link.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="group flex items-start gap-2 text-gray-700 hover:text-amber-700 transition-colors"
                    >
                      <ExternalLink className="w-4 h-4 mt-1 flex-shrink-0 group-hover:text-amber-700" />
                      <div>
                        <div className="font-medium group-hover:underline">{link.name}</div>
                        <div className="text-xs text-gray-500">{link.description}</div>
                      </div>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="text-center text-sm text-gray-600 mt-8">
          Ces liens externes vous aideront à préparer au mieux votre séjour sur l'Île de Ré
        </p>
      </div>
    </section>
  );
};

export default UsefulLinks;
